import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit {
  showSuccess: boolean;
  paymentId:any;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    let paymentResp = JSON.parse(sessionStorage.getItem("paymentResp"))
    this.showSuccess=paymentResp.status;
    this.paymentId=paymentResp.paymentId;
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-result/payment-result.component.ts